import Login from './Login.json';

const pl = {
  Login,
};

export default pl;
